import blockHelperDef from "./BlockHelper";
import buttonDef from "./Button";
import customConditionDef from "./Condition";
import conditionDef from "./Condition/BinaryConditional";
import conditionCaseDef from "./Condition/ConditionalCase";
import multiConditionDef from "./Condition/MultiConditional";
import containerDef from "./Container";
import feedbackMessageDef from "./FeedbackMessage";
import flexDef from "./Flex";
import formDef from "./Form";
import formContainerDef from "./Form/Container";
import formLoaderDef from "./Form/Loader";
import stepDef from "./Form/Step";
import formButtonsGridDef from "./Form/fields/FormButtonsGrid";
import formButtonGridDef from "./Form/fields/FormButtonsGrid/Button";
import formCheckBoxMultiDef from "./Form/fields/FormCheckBoxMulti";
import formCheckBoxMultiContainerDef from "./Form/fields/FormCheckBoxMulti/Container";
import formCheckBoxMultiInputDef from "./Form/fields/FormCheckBoxMulti/Input";
import formCheckBoxMultiLabelDef from "./Form/fields/FormCheckBoxMulti/Label";
import formCheckboxDef from "./Form/fields/FormCheckbox";
import formColDef from "./Form/fields/FormCol";
import formConsentDef from "./Form/fields/FormConsent";
import formConsentInputDef from "./Form/fields/FormConsent/Input";
import formConsentLabelDef from "./Form/fields/FormConsent/Label";
import formConsentInstructionsContainerDef from "./Form/fields/FormConsent/instructions/Container";
import formConsentInstructionsInputDef from "./Form/fields/FormConsent/instructions/Input";
import formConsentInstructionsTextDef from "./Form/fields/FormConsent/instructions/Instructions";
import formContinueButtonDef from "./Form/fields/FormContinueButton";
import formDOBDef from "./Form/fields/FormDOB";
import formDateDef from "./Form/fields/FormDate";
import formDateTripleSelectDef from "./Form/fields/FormDateTripleSelect";
import formFeedbackMessageDef from "./Form/fields/FormFeedbackMessage";
import formFieldWrapperDef from "./Form/fields/FormFieldWrapper";
import formH1Def from "./Form/fields/FormHeading/FormH1";
import formH2Def from "./Form/fields/FormHeading/FormH2";
import formH3Def from "./Form/fields/FormHeading/FormH3";
import formH4Def from "./Form/fields/FormHeading/FormH4";
import formH5Def from "./Form/fields/FormHeading/FormH5";
import formH6Def from "./Form/fields/FormHeading/FormH6";
import formInputDef from "./Form/fields/FormInput";
import formLabelDef from "./Form/fields/FormLabel";
import formPreviousButtonDef from "./Form/fields/FormPreviousButton";
import formRadioDef from "./Form/fields/FormRadio";
import formRadioContainerDef from "./Form/fields/FormRadio/Container";
import formRadioInputDef from "./Form/fields/FormRadio/Input";
import formRadioLabelDef from "./Form/fields/FormRadio/Label";
import formRadioMultiDef from "./Form/fields/FormRadioMulti";
import formRadioMultiContainerDef from "./Form/fields/FormRadioMulti/Container";
import formRadioMultiInputDef from "./Form/fields/FormRadioMulti/Input";
import formRadioMultiLabelDef from "./Form/fields/FormRadioMulti/Label";
import formRowDef from "./Form/fields/FormRow";
import formSelectDef from "./Form/fields/FormSelect";
import formTextAreaDef from "./Form/fields/FormTextArea";
import gridDef from "./Grid";
import gridContainerDef from "./Grid/Container";
import gridItemDef from "./Grid/Item";
import htmlDef from "./HTML";
import hbsVariableDef from "./HbsVariable";
import headingDef from "./Headings";
import imageDef from "./Image";
import inputDef from "./Input";
import labelDef from "./Label";
import layoutDef from "./Layout";
import layoutRootDef from "./LayoutRoot";
import linkDef from "./Link";
import midpathDef from "./Midpath";
import midpathContainerDef from "./Midpath/Container";
import midpathTCPAQuestionDef from "./Midpath/TCPAQuestion";
import midpathTCPAAnswerDef from "./Midpath/TCPAQuestion/Answer";
import midpathTCPAAnswerButtonDef from "./Midpath/TCPAQuestion/AnswerButton";
import midpathTCPAAnswersDef from "./Midpath/TCPAQuestion/Answers";
import midpathTCPAAnswerCheckboxDef from "./Midpath/TCPAQuestion/Checkbox";
import midpathTCPAConsentDef from "./Midpath/TCPAQuestion/Consent";
import midpathTCPAContinueButtonDef from "./Midpath/TCPAQuestion/ContinueButton";
import midpathTCPAContinueContainerDef from "./Midpath/TCPAQuestion/ContinueContainer";
import midpathTCPAErrorFeedbackDef from "./Midpath/TCPAQuestion/ErrorFeedback";
import midpathTCPAQuestionTitleDef from "./Midpath/TCPAQuestion/QuestionTitle";
import navigationDef from "./Navigation";
import navigationItemDef from "./Navigation/Item";
import optoutDef from "./Optout";
import optoutFeedbackDef from "./Optout/Feedback";
import optoutFormDef from "./Optout/Form";
import partialDef from "./Partial";
import partialRootDef from "./PartialRoot";
import placeholderDef from "./Placeholder";
import progressBarDef from "./ProgressBar";
import progressValueDef from "./ProgressBar/Value";
import pushProviderDef from "./PushProvider";
import recaptchaDef from "./Recaptcha";
import rewardDef from "./Reward";
import richTextDef from "./RichText";
import sectionDef from "./Section";
import separatorDef from "./Separator";
import tagDef from "./Tag";
import templateBlockDef from "./TemplateBlock";
import templateRootDef from "./TemplateRoot";
import textDef from "./Text";
import unsubscribeDef from "./Unsubscribe"
import unsubscribeFeedbackDef from "./Unsubscribe/Feedback";
import unsubscribeFeedbackTitleDef from "./Unsubscribe/Feedback/Title";
import unsubscribeFormDef from "./Unsubscribe/Form";
import unsubscribeFormAlertDef from "./Unsubscribe/Form/Alert";
import unsubscribeFormConfirmationDef from "./Unsubscribe/Form/Confirmation";
import variantsDef from "./Variants";
import variantsTabContentDef from "./Variants/TabContent";

export const blocks = [
  buttonDef,
  linkDef,
  separatorDef,
  gridDef,
  imageDef,
  inputDef,
  labelDef,
  feedbackMessageDef,
  layoutDef,
  layoutRootDef,
  partialDef,
  partialRootDef,
  gridContainerDef,
  gridItemDef,
  templateRootDef,
  textDef,
  formDef,
  formContainerDef,
  stepDef,
  formInputDef,
  formLabelDef,
  formFeedbackMessageDef,
  formSelectDef,
  formFieldWrapperDef,
  formLoaderDef,
  flexDef,
  headingDef,
  sectionDef,
  formContinueButtonDef,
  formDOBDef,
  containerDef,
  placeholderDef,
  formRowDef,
  formColDef,
  formCheckboxDef,
  formDateDef,
  formDateTripleSelectDef,
  formRadioDef,
  formConsentDef,
  formPreviousButtonDef,
  formButtonGridDef,
  formButtonsGridDef,
  midpathDef,
  midpathTCPAQuestionTitleDef,
  midpathTCPAAnswerDef,
  midpathTCPAAnswerButtonDef,
  midpathTCPAAnswersDef,
  midpathTCPAConsentDef,
  midpathTCPAErrorFeedbackDef,
  midpathTCPAContinueButtonDef,
  midpathTCPAContinueContainerDef,
  midpathTCPAQuestionDef,
  formCheckBoxMultiDef,
  formCheckBoxMultiContainerDef,
  formCheckBoxMultiLabelDef,
  formRadioMultiDef,
  formCheckBoxMultiInputDef,
  formRadioMultiContainerDef,
  formRadioMultiInputDef,
  formRadioMultiLabelDef,
  formConsentInputDef,
  formConsentLabelDef,
  formConsentInstructionsContainerDef,
  formConsentInstructionsInputDef,
  formConsentInstructionsTextDef,
  formRadioInputDef,
  formRadioLabelDef,
  formRadioContainerDef,
  formTextAreaDef,
  midpathContainerDef,
  midpathTCPAAnswerCheckboxDef,
  recaptchaDef,
  optoutDef,
  optoutFeedbackDef,
  optoutFormDef,
  unsubscribeDef,
  unsubscribeFormDef,
  unsubscribeFormConfirmationDef,
  unsubscribeFeedbackDef,
  unsubscribeFeedbackTitleDef,
  unsubscribeFormAlertDef,
  conditionDef,
  conditionCaseDef,
  multiConditionDef,
  navigationDef,
  navigationItemDef,
  progressBarDef,
  progressValueDef,
  htmlDef,
  tagDef,
  templateBlockDef,
  richTextDef,
  rewardDef,
  variantsDef,
  variantsTabContentDef,
  blockHelperDef,
  hbsVariableDef,
  pushProviderDef,
  formH1Def,
  formH2Def,
  formH3Def,
  formH4Def,
  formH5Def,
  formH6Def,
  customConditionDef,
]

const { Component: ButtonBlock } = buttonDef
const { Component: GridBlock } = gridDef
const { Component: ImageBlock } = imageDef
const { Component: InputBlock } = inputDef
const { Component: LabelBlock } = labelDef
const { Component: FeedbackMessageBlock } = feedbackMessageDef
const { Component: LayoutBlock } = layoutDef
const { Component: LayoutRootBlock } = layoutRootDef
const { Component: PartialBlock } = partialDef
const { Component: PartialRootBlock } = partialRootDef
const { Component: GridContainerBlock } = gridContainerDef
const { Component: GridItemBlock } = gridItemDef
const { Component: TemplateRootBlock } = templateRootDef
const { Component: TextBlock } = textDef
const { Component: FormContainerBlock } = formContainerDef
const { Component: StepBlock } = stepDef
const { Component: FormBlock } = formDef
const { Component: FormInputBlock } = formInputDef
const { Component: FormLabelBlock } = formLabelDef
const { Component: FormFeedbackMessageBlock } = formFeedbackMessageDef
const { Component: FormSelectBlock } = formSelectDef
const { Component: FormFieldWrapperBlock } = formFieldWrapperDef
const { Component: FormLoaderBlock } = formLoaderDef
const { Component: FlexBlock } = flexDef
const { Component: HeadingBlock } = headingDef
const { Component: SeparatorBlock } = separatorDef
const { Component: SectionBlock } = sectionDef
const { Component: FormContinueButtonBlock } = formContinueButtonDef
const { Component: FormDOBBlock } = formDOBDef
const { Component: ContainerBlock } = containerDef
const { Component: PlaceholderBlock } = placeholderDef
const { Component: FormRowBlock } = formRowDef
const { Component: FormColBlock } = formColDef
const { Component: FormCheckboxBlock } = formCheckboxDef
const { Component: FormDateBlock } = formDateDef
const { Component: FormDateTripleSelectBlock } = formDateTripleSelectDef
const { Component: FormRadioBlock } = formRadioDef
const { Component: FormConsentBlock } = formConsentDef
const { Component: FormPreviousButtonBlock } = formPreviousButtonDef
const { Component: FormButtonGridBlock } = formButtonGridDef
const { Component: FormButtonsGridBlock } = formButtonsGridDef
const { Component: MidpathBlock } = midpathDef
const { Component: MidpathTCPAQuestionBlock } = midpathTCPAQuestionDef
const { Component: MidpathTCPAAnswerBlock } = midpathTCPAAnswerDef
const { Component: MidpathTCPAAnswerButtonBlock } = midpathTCPAAnswerButtonDef
const { Component: MidpathTCPAAnswersBlock } = midpathTCPAAnswersDef
const { Component: MidpathTCPAConsentBlock } = midpathTCPAConsentDef
const { Component: MidpathTCPAErrorFeedbackBlock } = midpathTCPAErrorFeedbackDef
const { Component: MidpathTCPAContinueContainerBlock } = midpathTCPAContinueContainerDef
const { Component: MidpathTCPAContinueButtonBlock } = midpathTCPAContinueButtonDef
const { Component: MidpathTCPAQuestionTitleBlock } = midpathTCPAQuestionTitleDef
const { Component: FormCheckBoxMultiBlock } = formCheckBoxMultiDef
const { Component: FormCheckBoxMultiContainerBlock } = formCheckBoxMultiContainerDef
const { Component: FormCheckBoxMultiLabelBlock } = formCheckBoxMultiLabelDef
const { Component: FormRadioMultiBlock } = formRadioMultiDef
const { Component: FormCheckBoxMultiInputBlock } = formCheckBoxMultiInputDef
const { Component: FormRadioMultiContainerBlock } = formRadioMultiContainerDef
const { Component: FormRadioMultiInputBlock } = formRadioMultiInputDef
const { Component: FormRadioMultiLabelBlock } = formRadioMultiLabelDef
const { Component: FormConsentInputBlock } = formConsentInputDef
const { Component: FormConsentLabelBlock } = formConsentLabelDef
const { Component: FormConsentInstructionsContainerBlock } = formConsentInstructionsContainerDef
const { Component: FormConsentInstructionsInputBlock } = formConsentInstructionsInputDef
const { Component: FormConsentInstructionsTextBlock } = formConsentInstructionsTextDef
const { Component: FormRadioLabelBlock } = formRadioLabelDef
const { Component: FormRadioInputBlock } = formRadioInputDef
const { Component: FormRadioContainerBlock } = formRadioContainerDef
const { Component: FormTextAreaBlock } = formTextAreaDef
const { Component: MidpathContainerBlock } = midpathContainerDef
const { Component: MidpathTCPAAnswerCheckboxBlock } = midpathTCPAAnswerCheckboxDef
const { Component: LinkBlock } = linkDef
const { Component: RecaptchaBlock } = recaptchaDef
const { Component: OptoutBlock } = optoutDef
const { Component: OptoutFeedbackBlock } = optoutFeedbackDef
const { Component: OptoutFormBlock } = optoutFormDef
const { Component: UnsubscribeBlock } = unsubscribeDef
const { Component: UnsubscribeFormBlock } = unsubscribeFormDef
const { Component: UnsubscribeFormConfirmationBlock } = unsubscribeFormConfirmationDef
const { Component: UnsubscribeFeedbackBlock } = unsubscribeFeedbackDef
const { Component: UnsubscribeFeedbackTitleBlock } = unsubscribeFeedbackTitleDef
const { Component: UnsubscribeFormAlertBlock } = unsubscribeFormAlertDef
const { Component: ConditionBlock } = conditionDef
const { Component: ConditionCaseBlock } = conditionCaseDef
const { Component: MultiConditionBlock } = multiConditionDef
const { Component: NavigationBlock } = navigationDef
const { Component: NavigationItemBlock } = navigationItemDef
const { Component: ProgressBarBlock } = progressBarDef
const { Component: ProgressValueBlock } = progressValueDef
const { Component: HTMLBlock } = htmlDef
const { Component: TagBlock } = tagDef
const { Component: TemplateBlockBlock } = templateBlockDef
const { Component: RewardBlock } = rewardDef
const { Component: RichTextBlock } = richTextDef
const { Component: VariantsBlock } = variantsDef
const { Component: VariantsTabContentBlock } = variantsTabContentDef
const { Component: BlockHelperBlock } = blockHelperDef
const { Component: HbsVariableBlock } = hbsVariableDef
const { Component: PushProviderBlock } = pushProviderDef
const { Component: FormH1Block } = formH1Def
const { Component: FormH2Block } = formH2Def
const { Component: FormH3Block } = formH3Def
const { Component: FormH4Block } = formH4Def
const { Component: FormH5Block } = formH5Def
const { Component: FormH6Block } = formH6Def
const { Component: CustomConditionBlock } = customConditionDef

export {
  ButtonBlock,
  GridBlock,
  ImageBlock,
  InputBlock,
  LabelBlock,
  FeedbackMessageBlock,
  LayoutBlock,
  LayoutRootBlock,
  PartialBlock,
  PartialRootBlock,
  GridContainerBlock,
  GridItemBlock,
  TemplateRootBlock,
  TextBlock,
  FormContainerBlock,
  FormRowBlock,
  FormColBlock,
  StepBlock,
  FormBlock,
  FormInputBlock,
  FormCheckboxBlock,
  FormDateBlock,
  FormDateTripleSelectBlock,
  FormLabelBlock,
  FormFeedbackMessageBlock,
  FormSelectBlock,
  FormFieldWrapperBlock,
  FormLoaderBlock,
  FlexBlock,
  HeadingBlock,
  SeparatorBlock,
  SectionBlock,
  FormContinueButtonBlock,
  FormDOBBlock,
  ContainerBlock,
  PlaceholderBlock,
  FormRadioBlock,
  FormConsentBlock,
  FormPreviousButtonBlock,
  FormButtonGridBlock,
  FormButtonsGridBlock,
  MidpathBlock,
  MidpathTCPAQuestionBlock,
  MidpathTCPAAnswerBlock,
  MidpathTCPAAnswerButtonBlock,
  MidpathTCPAAnswersBlock,
  MidpathTCPAConsentBlock,
  MidpathTCPAErrorFeedbackBlock,
  MidpathTCPAContinueContainerBlock,
  MidpathTCPAContinueButtonBlock,
  MidpathTCPAQuestionTitleBlock,
  FormCheckBoxMultiBlock,
  FormCheckBoxMultiContainerBlock,
  FormCheckBoxMultiLabelBlock,
  FormRadioMultiBlock,
  FormCheckBoxMultiInputBlock,
  FormRadioMultiContainerBlock,
  FormRadioMultiInputBlock,
  FormRadioMultiLabelBlock,
  FormConsentInputBlock,
  FormConsentLabelBlock,
  FormConsentInstructionsContainerBlock,
  FormConsentInstructionsInputBlock,
  FormConsentInstructionsTextBlock,
  FormRadioLabelBlock,
  FormRadioInputBlock,
  FormRadioContainerBlock,
  FormTextAreaBlock,
  MidpathContainerBlock,
  MidpathTCPAAnswerCheckboxBlock,
  LinkBlock,
  RecaptchaBlock,
  OptoutBlock,
  OptoutFeedbackBlock,
  OptoutFormBlock,
  UnsubscribeBlock,
  UnsubscribeFormBlock,
  UnsubscribeFormConfirmationBlock,
  UnsubscribeFeedbackBlock,
  UnsubscribeFeedbackTitleBlock,
  UnsubscribeFormAlertBlock,
  ConditionBlock,
  ConditionCaseBlock,
  MultiConditionBlock,
  NavigationBlock,
  NavigationItemBlock,
  ProgressBarBlock,
  ProgressValueBlock,
  HTMLBlock,
  TagBlock,
  TemplateBlockBlock,
  RichTextBlock,
  RewardBlock,
  VariantsBlock,
  VariantsTabContentBlock,
  BlockHelperBlock,
  HbsVariableBlock,
  PushProviderBlock,
  FormH1Block,
  FormH2Block,
  FormH3Block,
  FormH4Block,
  FormH5Block,
  FormH6Block,
  CustomConditionBlock,
}
